import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { lightTheme, darkTheme } from 'theme';
import { MuiThemeProvider } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Logo from './Logo';

const NavAppBar = styled(AppBar)`
  margin-bottom: -64px;
  position: relative;
  z-index: 1299;
  padding-right: 0 !important;
`;

const NavToolbar = styled(Toolbar)`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

const BackWrapper = styled.div`
  margin-right: auto;
`;

const colorToTheme = {
  default: darkTheme,
  primary: lightTheme
};

const NavBar = ({ color, colorOverride, backButton, children }) => {
  return (
    <NavAppBar
      elevation={0}
      color={colorOverride || color}
      data-swiftype-index="false"
    >
      <NavToolbar>
        {backButton ? (
          <BackWrapper>{backButton}</BackWrapper>
        ) : (
          <Logo color={colorOverride || color} />
        )}
        {children && (
          <MuiThemeProvider theme={colorToTheme[colorOverride || color]}>
            {children}
          </MuiThemeProvider>
        )}
      </NavToolbar>
    </NavAppBar>
  );
};

export default connect(
  state => ({
    color: state.navigation.color
  }),
  {}
)(NavBar);
